module.exports = __webpack_public_path__ + "img/803537_310F10_C35A5D_D89093-256px.f08023ba.png";